import texts from './texts';
import {ModalTypes} from './enums';
import {noop} from '@priority-software/priority-style-react';

export type BooleanNumber = 0 | 1;

export type OB_tab_info = {
    id: string;
    ready: BooleanNumber;
};

export const default_OB_context = {
    OB_is_open: false,
    OB_dialog_type: ModalTypes.hidden,
    open_OB_dialog: noop,
    close_OB_dialog: noop,
    leave_OB_process: noop,

    dataCheck_callback: noop,
    check_unsaved_data: noop,
    close_save_data_alert: noop,
    data_alert_is_open: false,

    open_skip_OB_alert: noop,
    close_skip_OB_alert: noop,
    skip_OB_is_open: false,

    OB_process_start: noop,
    OB_process_skip: noop
};

export const defaultTabsData: Array<OB_tab_info> = [
    {id: `0`, ready: 0},
    {id: `1`, ready: 0},
    {id: `2`, ready: 0},
    {id: `3`, ready: 0}
];

export const tabsTitleMap = {
    '0': texts.company_tab_title,
    '1': texts.bank_acc_tab_title,
    '2': texts.general_info_tab_title,
    '3': texts.summary_tab_title
};
